import { render } from "./VPopup.vue?vue&type=template&id=1d47a4d8"
import script from "./VPopup.vue?vue&type=script&lang=js"
export * from "./VPopup.vue?vue&type=script&lang=js"

import "./VPopup.vue?vue&type=style&index=0&id=1d47a4d8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__